import React from "react";
import "../styles/why-cloudare.css";
import { PhosphorIcon } from "./PhosphorIcon";

/**
 * WhyCloudare — flow-based feature grid. No absolute positioning, no negative
 * margins, no transforms that layer content. Physically cannot reproduce the
 * overlapping-H2 bug.
 *
 * Props:
 *   eyebrow   - small uppercase label (default "Why Cloudare")
 *   title     - section H2
 *   lede      - one-sentence value prop
 *   features  - [{ icon, title, body }]
 *   elevated  - if true, uses --surface-elevated background
 */
export default function WhyCloudare({
  eyebrow = "Why Cloudare",
  title,
  lede,
  features = [],
  elevated = true,
}) {
  return (
    <section
      className="why-cloudare"
      style={
        elevated ? undefined : { background: "var(--surface)" }
      }
    >
      <header className="why-cloudare__header">
        <p className="why-cloudare__eyebrow">{eyebrow}</p>
        <h2 className="why-cloudare__title">{title}</h2>
        {lede && <p className="why-cloudare__lede">{lede}</p>}
      </header>

      <div className="why-cloudare__grid">
        {features.map((f, i) => (
          <article className="wc-card" key={i}>
            <div className="wc-card__icon">
              <PhosphorIcon name={f.icon} size={24} />
            </div>
            <h3 className="wc-card__title">{f.title}</h3>
            <p className="wc-card__body">{f.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
